import best from '../assets/besteats1.png'
import weekaway from '../assets/weekaway.png'
import trendy from '../assets/trendy.png'
import privatebeaches from '../assets/privatebeaches.png'
import netflix from '../assets/netflix.png'
import moviecard from '../assets/moviecard.png'
import dishes from '../assets/dishes.png'
import crypto from '../assets/crypto.png'
export const PortfolioData = [
    {
        id:1,
        image: crypto,
        description:'React, React-sparklines, Context-api, React-hot-toast, React-hooks, Tailwind ',
        website:'https://ecommerce-5596d.web.app/',
        github: 'https://github.com/EvansRobbie/CryptoCoin'
    },
    {
        id:2,
        image: weekaway,
        description:'Landing page using React and Tailwind Css',
        website:'https://github.com/EvansRobbie/weekaway',
        github: 'https://awayweek.netlify.app/'
    },
    {
        id:3,
        image: netflix,
        description:'React, React-router, context-api, useNavigate, Firebase, Firestore, Firebase-auth, Tailwind',
        website:'https://sharemerobbie.web.app/',
        github: 'https://github.com/EvansRobbie/netflixClone_Firebase'
    },
    {
        id:4,
        image: privatebeaches,
        description:'React, useState-hook, Masonry-grid, Tailwind Css',
        website:'https://privatebeaches.netlify.app/',
        github: 'https://github.com/EvansRobbie/PrivateBeaches'
    },
    {
        id:5,
        image: best,
        description:'React, Context-api, Reducer, React-hot-toast, Tailwind',
        website:'https://dinerbesteats.netlify.app/',
        github: 'https://github.com/EvansRobbie/BestEats'
    },
    {
        id:6,
        image: trendy,
        description:'React, React-router, react-hooks, LocalStorage, Tailwind',
        website:'https://trendyclothes.netlify.app/',
        github: 'https://github.com/EvansRobbie/trendyshop'
    },
    {
        id:7,
        image: moviecard,
        description:'TMDB-api, React,Fetch, useEffect-Hook, Css3',
        website:'https://movie-cardreact.netlify.app/',
        github: 'https://github.com/EvansRobbie/ReactMovieCard'
    },
    {
        id:8,
        image: dishes,
        description:'React, React-context-api, useState, axios, Custome-hook, css3',
        website:'https://dishrecipes.netlify.app/',
        github: 'https://github.com/EvansRobbie/dishRecipes'
    },
]